module.exports = __webpack_public_path__ + "static/media/banner.53ed423e.png";